import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import {
  HttpHeaders,
  HttpClient,
  HttpBackend,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { catchError, map } from "rxjs/operators";
import { Router } from "@angular/router";
import { StorageService } from "./storage.service";
import { StorageKey } from "./storage.model";
import { NgxPermissionsService } from "ngx-permissions";
import { AdminService } from "../admin/admin-service";
import { MixinFunctionsService } from "./mixin-functions.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { SessionDialogComponent } from "../login/session-dialog/session-dialog.component";
import Swal from "sweetalert2";
const { AUTH_TOKEN } = StorageKey;
const { CURRENT_USER } = StorageKey;
const { EXPIRE } = StorageKey;
const { REFRESH_TOKEN } = StorageKey;
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  timeForTokenToExpire: string;
  token: string;
  redirectUrl: string;
  info: string;
  position: any;
  userPosition: any;
  userInfo: any;
  profile: any;
  sessionDialog: MatDialogRef<SessionDialogComponent>;
  isDialogCall = false;
  constructor(
    private storage: StorageService,
    private service: AdminService,
    private http: HttpClient,
    private permissionsService: NgxPermissionsService,
    private router: Router,
    private httpBackend: HttpBackend,
    private mixins: MixinFunctionsService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {}

  login(username: string, pwd: string, data = null): Observable<any> {
    const body = `username=${encodeURIComponent(
      username
    )}&password=${encodeURIComponent(pwd)}&grant_type=password`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      Authorization:
        "Basic " + btoa(environment.CLIENTID + ":" + environment.CLIENTSECRET),
      notoken: "notoken",
    });
    return this.http
      .post<any>(`/api/oauth/token`, body, {
        headers,
      })
      .pipe(
        map(
          (user) => {
            if (user && user.access_token) {
              this.timeForTokenToExpire = JSON.stringify(user.expires_in);

              localStorage.setItem(
                "currentClient",
                JSON.stringify(user.access_token)
              );

              localStorage.setItem(
                "refreshToken",
                JSON.stringify(user.refresh_token)
              );
              localStorage.setItem(
                "EXPIRE",
                JSON.stringify(user.refresh_token)
              );
              localStorage.setItem(
                "expireTime",
                JSON.stringify(user.expires_in)
              );

              this.authRole(data);
            }
            return user;
          },
          (err: any) => {
            if (this.isDialogCall) {
              Swal.fire(err.error_description, "", "error");
            }
          }
        )
      );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  logout(data = null) {
    //console.log("data is", data);
    const token = JSON.parse(localStorage.getItem("currentClient"));
    const refreshToken = JSON.parse(localStorage.getItem("refreshToken"));

    const params = {
      token: token,
      refreshToken: refreshToken,
      access_token: token,
    };

    if (token !== null && refreshToken !== null) {
      const newHttpClient = new HttpClient(this.httpBackend);
      return newHttpClient
        .get<any>("/api/user/oauth/token/revoke", { params: params })
        .subscribe(
          (response) => {
            if (response.code === 200) {
              this.isDialogCall && data === null
                ? this.clearCurrentSession()
                : this.clearSession();
            }
          },
          (error) => {
            this.isDialogCall
              ? this.clearCurrentSession()
              : this.clearSession();
          }
        );
    }
  }

  capture(): Observable<any> {
    return this.http
      .get("/api/applicant/getRecaptcha")
      .pipe(catchError(this.handleError));
  }

  verify(param): Observable<any> {
    return this.http
      .get("/api/applicant/getRecaptcha/" + param)
      .pipe(catchError(this.handleError));
  }

  authRole(data = null) {
    this.http.get("api/user").subscribe(
      (response) => {
        if (response["code"] === 200) {
          //saves FY if user return success response

          this.mixins.getCurrentFy();

          localStorage.setItem("userInfo", JSON.stringify(response));

          const info = JSON.parse(localStorage.getItem("userInfo"));
          this.userInfo = info["data"].principal;
          this.info = JSON.parse(localStorage.getItem("userInfo"));
          // console.log("User Informations", this.info);
          //close Dialog after request call
          if (data && data.isSessionRestore) {
            // this data is always from the dialog

            this.sessionDialog.componentInstance.closeDialog();
          }

          if (this.info) {
            this.position = this.info["data"].principal;
            if (this.position) {
              const usr = this.position["position"];
              if (usr) {
                this.userPosition = usr.name;

                if (this.userPosition === "Group Admin") {
                  this.service.profile().subscribe((response) => {
                    if (response) {
                      this.profile = response.data;

                      /** checks if user login is restoring current session and redirects to current page*/
                      if (data && data.isSessionRestore) {
                        return this.router.navigate([data.currentUrl]);
                      }

                      if (this.profile) {
                        this.router.navigate(["/main/group-dashboard"]);
                      } else {
                        this.router.navigate(["/main/group/members"]);
                      }
                    }
                  });
                } else {
                  /** checks if user login is restoring current session */
                  if (data && data.isSessionRestore) {
                    return this.router.navigate([data.currentUrl]);
                  }

                  if (this.userInfo.firstLogin) {
                    return this.router.navigate(["/main/change-password"]);
                  } else {
                    // console.log("executing here", this.router.url);

                    if (!["/main", "/login"].includes(this.router.url)) {
                      return this.router.navigate([this.router.url]);
                    } else {
                      return this.router.navigate(["/main"]);
                    }
                  }
                }
                const perms = [];
                perms.push(this.userPosition);
                // console.log("Permission Added", this.userPosition);

                this.permissionsService.loadPermissions(perms);
              }
            }
          }
        } else {
          //
          //logout user once /api/user call failed
          this.clearSession();
          if (data && data.isSessionRestore) {
            // this data is always from the dialog

            this.sessionDialog.componentInstance.closeDialog();

            Swal.fire(response["error_description"], "", "error");
          }
        }
      },
      (error) => {
        //

        //logout user once /api/user call failed
        this.clearSession();
      }
    );
  }

  clearSession() {
    localStorage.removeItem("currentClient");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expireTime");
    localStorage.removeItem("userInfo");
    this.router.navigate(["login"]);
    window.sessionStorage.clear();
    localStorage.removeItem("cFy");
  }
  public expireTime(expireDuration) {
    return Number(new Date(Date.now() + expireDuration));
  }

  public isLogged(): boolean {
    try {
      const expire = this.storage.read(EXPIRE);
      return !!expire;
    } catch (e) {
      return false;
    }
  }

  public tokenExists(): boolean {
    return this.token !== "";
  }

  public user(): any {
    return this.storage.read(CURRENT_USER);
  }

  public isLoggedIn() {
    const hasSession =
      JSON.parse(localStorage.getItem("currentClient")) &&
      JSON.parse(localStorage.getItem("currentClient")) !== null &&
      JSON.parse(localStorage.getItem("EXPIRE")) &&
      JSON.parse(localStorage.getItem("EXPIRE")) !== null
        ? true
        : false;

    if (this.mixins.currentUser?.position === "Group Admin" && hasSession) {
      this.router.navigate(["/main/group-dashboard"]);
    } else if (hasSession) {
      this.router.navigate(["/main"]);
    } else {
      this.router.navigate(["/login"]);
    }
  }

  get hasSession() {
    return JSON.parse(localStorage.getItem("currentClient")) &&
      JSON.parse(localStorage.getItem("currentClient")) !== null &&
      JSON.parse(localStorage.getItem("EXPIRE")) &&
      JSON.parse(localStorage.getItem("EXPIRE")) !== null
      ? true
      : false;
  }

  hasActiveSession() {
    if (!this.hasSession) {
      this.router.navigate(["/login"]);
    }
  }

  clearCurrentSession() {
    localStorage.removeItem("currentClient");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expireTime");
  }

  openSessionDialog(): void {
    this.isDialogCall = true;
    this.sessionDialog = this.dialog.open(SessionDialogComponent, {
      width: "700px",
      disableClose: true,
      data: {},
    });
    /** All dialogs operations here */

    this.sessionDialog.componentInstance.params = {
      save: (data: any) => {
        this.isDialogCall = true;
        this.sessionDialog.componentInstance.loading = true;
        this.login(data.username, data.password, { ...data })
          .pipe()
          .subscribe(
            (resp) => {
              if (resp && resp.access_token) {
                this.sessionDialog.componentInstance.loading = false;
              }
            },
            (error) => {
              this.sessionDialog.componentInstance.loading = false;
              this.toastr.error(
                error.error ? error?.error?.error_description : "Unauthorized",
                "",
                {
                  timeOut: 8000,
                }
              );
              //Swal.fire(error?.error?.error_description, "", "error");
            }
          );
      },
    };

    this.logout();
  }
}
